<div [innerHTML]="text | keepHtml | multiLine | twemoji"></div>
